import { useCallback, useState } from "react";

export interface JustCompletedSteps {
  justCompletedStepIds: Set<number>;
  markStepJustCompleted: (stepId: number) => void;
}

/**
 * Tracks session-step ids whose purchase completed on this page mount.
 *
 * Used by CheckoutSessionContext to suppress the already-purchased alert for
 * a purchase the member just made themselves (see MainOfferPage), never for
 * an existing prior purchase. State (not a ref), since the consumer must
 * re-render to suppress the alert as soon as a step is marked.
 */
export const useJustCompletedSteps = (): JustCompletedSteps => {
  const [justCompletedStepIds, setJustCompletedStepIds] = useState<Set<number>>(
    () => new Set(),
  );

  const markStepJustCompleted = useCallback((stepId: number) => {
    setJustCompletedStepIds(previous => {
      if (previous.has(stepId)) {
        return previous;
      }
      return new Set(previous).add(stepId);
    });
  }, []);

  return { justCompletedStepIds, markStepJustCompleted };
};
